var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "email",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.692,
    height: 13.476,
    viewBox: "0 0 17.692 13.476",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_177",
    "data-name": "Group 177"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_435",
    "data-name": "Path 435",
    d: "M16.137,61H1.555A1.558,1.558,0,0,0,0,62.555V72.921a1.557,1.557,0,0,0,1.555,1.555H16.137a1.557,1.557,0,0,0,1.555-1.555V62.555A1.557,1.557,0,0,0,16.137,61Zm-.215,1.037L8.879,69.08l-7.1-7.043ZM1.037,72.707V62.765l4.992,4.95Zm.733.733,5-5,1.75,1.735a.518.518,0,0,0,.731,0l1.707-1.707,4.968,4.968Zm14.886-.733-4.968-4.968,4.968-4.969Z",
    transform: "translate(0 -61)",
    fill: "#8f768f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailicon);
export default __webpack_public_path__ + "static/media/email icon.e78c149e9c7020f9d9213130a2a5ac99.svg";
export { ForwardRef as ReactComponent };